import { jsx } from "react/jsx-runtime";
import { SvgIcon } from "@mui/material";
function RouteManagerLogoIconContrast(props) {
  const { width = "100%", sx = {}, ...rest } = props;
  return /* @__PURE__ */ jsx(
    SvgIcon,
    {
      "data-testid": "routeManagerLogo",
      titleAccess: "RouteManager Logo",
      viewBox: "0 0 100 101",
      sx: { ...sx, height: "auto", width },
      ...rest,
      children: /* @__PURE__ */ jsx(
        "path",
        {
          d: "M57.51.949C30.213-3.201 4.72 15.57.575 42.872c-4.15 27.3 14.62 52.797 41.917 56.943 27.297 4.145 52.79-14.622 56.934-41.923C103.572 30.59 84.806 5.099 57.51.949ZM42.79 83.952a2.8 2.8 0 0 1-2.279 1.194l-5.819.036a2.81 2.81 0 0 1-2.413-1.349L13.112 52.28a2.796 2.796 0 0 1 .052-2.993L32.61 19.654a2.8 2.8 0 0 1 2.34-1.266l11.411.005c2.274 0 3.597 2.563 2.285 4.419l-2.936 4.15a2.896 2.896 0 0 1-2.372 1.225l-2.594-.005c-.93 0-1.799.455-2.32 1.225l-13.5 19.817a2.908 2.908 0 0 0-.082 3.142l10.465 17.238c1.034 1.705 3.468 1.814 4.651.207L55.091 49.26l-2.574-1.447L65.323 42.2l.858 13.314-2.522-1.421-20.868 29.86Zm44.047-32.96L67.39 80.624a2.8 2.8 0 0 1-2.341 1.266l-11.396-.005c-2.274 0-3.602-2.574-2.279-4.425l2.956-4.15a2.902 2.902 0 0 1 2.367-1.22l2.558.005c.93 0 1.799-.455 2.32-1.225l13.5-19.811c.64-.941.671-2.166.082-3.143L64.693 30.68c-1.034-1.706-3.468-1.814-4.651-.207L44.91 51.022l2.574 1.448-12.806 5.613-.858-13.314 2.522 1.42 20.873-29.858a2.8 2.8 0 0 1 2.279-1.194l5.82-.037a2.81 2.81 0 0 1 2.413 1.35l19.167 31.554c.558.92.538 2.088-.057 2.987Z",
          fill: "#fff"
        }
      )
    }
  );
}
export {
  RouteManagerLogoIconContrast
};
//# sourceMappingURL=RouteManagerLogoIconContrast.js.map
